export default "__VITE_ASSET__Bv9Nzti1__"